// src/routes/productTypesRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import ProductTypes from '../pages/productTypes/ProductTypes';
import CreateProductTypes from '../pages/productTypes/CreateProductTypes';
import EditProductTypes from '../pages/productTypes/EditProductTypes';
import ProtectedRoute from '../components/global/ProtectedRoute';

const productTypesRoutes = (
    <>
        {/* Product Types List */}
        <Route
            path="/product-types"
            element={
                <ProtectedRoute requiredPermission="productTypes_list">
                    <ProductTypes />
                </ProtectedRoute>
            }
        />

        {/* Product Types Archive */}
        <Route
            path="/product-types/archive"
            element={
                <ProtectedRoute requiredPermission="productTypes_archive_list">
                    <ProductTypes />
                </ProtectedRoute>
            }
        />

        {/* Create Product Type */}
        <Route
            path="/product-types/create"
            element={
                <ProtectedRoute requiredPermission="productTypes_create">
                    <CreateProductTypes />
                </ProtectedRoute>
            }
        />

        {/* Edit Product Type */}
        <Route
            path="/product-types/:id/edit"
            element={
                <ProtectedRoute requiredPermission="productTypes_edit">
                    <EditProductTypes />
                </ProtectedRoute>
            }
        />
    </>
);

export default productTypesRoutes;